<template>
    <div class="main-content">
        <the-header :title="t('Patients')" :buttons="headerButtons"/>
        <data-grid ref="dataGrid"
                   :settings="grid"
                   :storeDispatchList="loadGridData"
                   :page="parseInt($route.params.page)"
                   v-on:changePage="$router.push({name: $route.name, params: {page: $event}})"
                   v-on:button-notify="notify($event)"
                   v-on:button-delete="confirmDelete($event)"
        >
            <router-link :to="{name: 'managePatient', params: {id: data.item.id, tab: 'base'}}"
                         slot="fullName"
                         slot-scope="data"
                         class="link"
            >
                <div>{{data.item.fullName}}</div>
                <img src="/static/insurance/dovera.svg"
                     v-if="data.item.insurance.code === 24"
                     class="insurance-logo"
                     :alt="data.item.insurance.insuranceName"
                >
                <img src="/static/insurance/vszp.png"
                     v-if="data.item.insurance.code === 25"
                     class="insurance-logo"
                     :alt="data.item.insurance.insuranceName"
                >
                <img src="/static/insurance/union.svg"
                     v-if="data.item.insurance.code === 27"
                     class="insurance-logo"
                     :alt="data.item.insurance.insuranceName"
                >
            </router-link>
            <template slot="lastApplicationState" slot-scope="data">
                <div v-if="data.item.applications.length !== 0"
                     class="badge"
                     :class="'badge-' + data.item.applications[0].status.color"
                >
                    {{data.item.applications[0].status.status}}
                </div>
            </template>
        </data-grid>
        <notification ref="notifyPatient"/>
        <b-modal
          :title="t('Delete')"
          ref="patientDeleteModal"
          >
          <div class="d-block pt-3 pb-3 text-center">
            <font-awesome-icon icon="times" size="3x"/>
            <div class="mt-1" v-if="patientToDelete.applications.length === 0">
              {{t('Do you want to delete patient?')}}
            </div>
            <div class="mt-1" v-if="patientToDelete.applications.length > 0">
              <p>{{ t('Patient has filled out applications') }}</p>
              <div>{{ t('Total') }}: {{patientToDelete.applications.length}}</div>
              <div v-for="status in uniq(patientToDelete.applications.map(app => app.status.id))">
                {{ patientToDelete.applications.find(app => app.status.id === status).status.status }}:
                {{ patientToDelete.applications.filter(app => app.status.id === status).length }}
              </div>
              <p>
                <router-link :to="{name: 'managePatient', params: {id: patientToDelete.id, tab:'applications'}}">
                  {{ t('View applications')}}
                </router-link>
              </p>
              <div class="mt-1">
                {{t('Do you want to delete patient alongside with applications?')}}
              </div>
            </div>
          </div>
          <div slot="modal-footer">
            <button type="button" class="btn btn-danger btn-sm" @click="cancelDelete()">
              <font-awesome-icon icon="times"/>
              {{t('No')}}
            </button>
            <button type="button" class="btn btn-success btn-sm" @click="deleteItem()">
              <font-awesome-icon icon="check"/>
              {{t('Yes')}}
            </button>
          </div>
        </b-modal>
    </div>
</template>

<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import DataGrid from '../../../core/InlineDataGrid/DataGrid'
    import Notification from './notification';
    import { uniq } from 'lodash';

    export default {
        components: {
            Notification,
            TheHeader,
            DataGrid,
        },
        methods: {
            uniq,
            notify(patient) {
                this.$refs.notifyPatient.openModal(patient);
            },
            confirmDelete(entity) {
              this.patientToDelete = entity;
              this.$refs.patientDeleteModal.show();
            },
            deleteItem() {
                this.$store.dispatch('patients/remove', this.patientToDelete.id).then(() => {
                    this.$refs.dataGrid.fetchData(true);
                    this.patientToDelete = {
                      id: 0,
                      applications: []
                    };
                    this.$refs.patientDeleteModal.hide();
                });
            },
            cancelDelete() {
              this.patientToDelete = {
                id: 0,
                applications: []
              };
              this.$refs.patientDeleteModal.hide();
            },
            loadGridData(params) {
                // const birthYearIndex = params.conditions.findIndex(res => {
                //     return res.key === 'birthYear';
                // });
                // if (birthYearIndex !== -1) {
                //     let year = (new Date()).getFullYear();
                //     params.conditions[birthYearIndex].value = year - parseInt(params.conditions[birthYearIndex].value);
                // }
                return this.$store.dispatch('patients/list', params)
            },
        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'link',
                        to: {name: 'createPatient', params: {tab: 'base'}},
                        key: 'create',
                        name: this.t('Create'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                        visible: () => {
                            return this.hasPermission('PatientsTitan', 'C');
                        },
                    }
                ],
                patientToDelete: {
                  id: 0,
                  applications: []
                },
                grid: {
                    buttons: [
                        {
                            type: 'link',
                            to: (item) => {
                                return {
                                    name: 'managePatient',
                                    params: {
                                        id: item.id,
                                        tab: 'base',
                                    },
                                };
                            },
                            name: this.t('Edit'),
                            icon: 'pencil-alt',
                            styleClass: 'btn-primary btn-sm mr-0',
                        }, {
                            type: 'button',
                            key: 'notify',
                            name: this.t('Notify'),
                            icon: 'bell',
                            styleClass: 'btn-warning btn-sm',
                            visible: () => {
                                return this.isNotIntKar();
                            },
                        }, {
                            type: 'button',
                            key: 'delete',
                            name: this.t('Delete'),
                            modalText: this.t('Do you want to delete patient?'),
                            icon: 'times',
                            styleClass: 'btn-danger btn-sm',
                            visible: () => {
                                return this.hasPermission('PatientsTitan', 'D');
                            },
                        }
                    ],
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Name'),
                            key: 'fullName',
                            sortField: ['name', 'surname'],
                            filter: {
                                field: ['name', 'surname'],
                                type: 'fulltext',
                                likeType: '%_like_',
                            },
                        }, {
                            type: 'number',
                            name: this.t('Number of applications'),
                            key: 'applicationsCount',
                            sortable: false,
                        }, {
                            type: 'string',
                            name: this.t('State of last applications'),
                            key: 'lastApplicationState',
                            sortable: false,
                            filter: {
                                // field: ['patient->applications->status->status'],
                                field: ['applications.*.status.status'],
                                type: 'fulltext',
                                likeType: '%_like_',
                            },
                        }, {
                            type: 'number',
                            name: this.t('Age'),
                            key: 'age',
                            sortField: 'birthYear',
                            filter: {
                                field: 'birthYear',
                                type: 'number',
                                postProcessFilterValue(value) {
                                  let year = (new Date()).getFullYear();
                                  return year - parseInt(value);
                                },
                            },
                        }, {
                            type: 'date',
                            name: this.t('Created on'),
                            key: 'dateCreated',
                            filter: {
                                type: 'dateRange',
                            },
                        }
                    ],
                },
            }
        },
    }
</script>
<style lang="scss">
    .insurance-logo {
        height: 15px;
        margin-top: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/private/patients/list.vue